import React, { createContext, useContext, useState } from 'react';
import mechanic1Img from './../assets/images/mechanic/mechanic1.jpg';
import mechanic2Img from './../assets/images/mechanic/mechanic2.jpg';
import mechanic3Img from './../assets/images/mechanic/mechanic3.jpg';
import mechanic4Img from './../assets/images/mechanic/mechanic4.jpg';
import mechanic5Img from './../assets/images/mechanic/mechanic5.jpg';
import mechanic6Img from './../assets/images/mechanic/mechanic6.jpg';
import mechanic7Img from './../assets/images/mechanic/mechanic7.jpg';
import mechanic8Img from './../assets/images/mechanic/mechanic8.jpg';
import mechanic9Img from './../assets/images/mechanic/mechanic9.jpg';
import mechanic10Img from './../assets/images/mechanic/mechanic10.jpg';

// Create Context
const MechanicContext = createContext();

// Custom Hook to use Mechanic Context
export const useMechanic = () => {
  const context = useContext(MechanicContext);
  if (!context) {
    throw new Error('useMechanic must be used within MechanicProvider');
  }
  return context;
};

// Mechanic Provider Component
export const MechanicProvider = ({ children }) => {

  const [allMechanics] = useState([
    {
      id: 1,
      image: mechanic1Img,
      name: 'Zulfiqar Ahmed',
      title: 'Senior Mechanic',
      rating: 5,
      specialization: 'Engine Specialist',
      experience: '10 Years',
      location: 'Gujranwala',
      phone: '+92 300 4112233',
      email: 'zulfiqar.mechanic@gmail.com',
      description:
        'Zulfiqar Ahmed has 10 years of hands-on experience repairing tractor engines. He specializes in diesel engine overhaul, fuel pump calibration, injector cleaning, and oil system servicing for Massey Ferguson 385, MF 240, and Chinese tractor models. He is known for fast, reliable, and affordable engine repairs across Gujranwala.',
      skills: ['Diesel Engine Overhaul', 'Fuel Pump Setting', 'Injector Cleaning', 'Oil System', 'Engine Tuning'],
      availability: 'Available'
    },
    {
      id: 2,
      image: mechanic2Img,
      name: 'Tariq Mehmood',
      title: 'Electrical Mechanic',
      rating: 4,
      specialization: 'Electrical & Wiring Specialist',
      experience: '8 Years',
      location: 'Lahore',
      phone: '+92 321 5566778',
      email: 'tariq.electric@gmail.com',
      description:
        'Tariq Mehmood is an electrical mechanic with 8 years of experience in tractor wiring and electrical systems. He efficiently handles battery failures, self-starter issues, short circuits, and lighting problems. He serves farmers across Lahore and surrounding districts with quick on-site electrical diagnostics and repairs.',
      skills: ['Battery & Alternator', 'Self-Starter Repair', 'Wiring & Short Circuit', 'Lights System', 'Electrical Diagnostics'],
      availability: 'Available'
    },
    {
      id: 3,
      image: mechanic3Img,
      name: 'Pervez Akhtar',
      title: 'Hydraulic Expert',
      rating: 5,
      specialization: 'Hydraulic Specialist',
      experience: '12 Years',
      location: 'Faisalabad',
      phone: '+92 333 9988776',
      email: 'pervez.hydraulic@gmail.com',
      description:
        'Pervez Akhtar is a highly experienced hydraulic specialist with 12 years in the field. He resolves tractor lifting failures, oil leakage, low hydraulic pressure, and damaged pipes. He also services hydraulic systems on combine harvesters and rotavators. Farmers across Faisalabad trust him for precise and durable hydraulic repairs.',
      skills: ['Hydraulic Pump Repair', 'Oil Leakage Fix', 'Lift System', 'Pressure Setting', 'Pipe Replacement'],
      availability: 'Busy'
    },
    {
      id: 4,
      image: mechanic4Img,
      name: 'M Ashraf',
      title: 'Transmission Mechanic',
      rating: 4,
      specialization: 'Transmission / Gear Specialist',
      experience: '9 Years',
      location: 'Sialkot',
      phone: '+92 346 7712345',
      email: 'ashraf.gear@gmail.com',
      description:
        'Muhammad Ashraf has 9 years of expertise in tractor gearbox and transmission systems. He handles gear slipping, clutch plate replacement, power transfer failures, and differential repairs. His thorough knowledge of transmission mechanics has made him the most recommended gear specialist for large farming operations in Sialkot.',
      skills: ['Gearbox Overhaul', 'Clutch Plate Replacement', 'Transmission Repair', 'Power Transfer', 'Differential Repair'],
      availability: 'Available'
    },
    {
      id: 5,
      image: mechanic5Img,
      name: 'Sajid Hussain',
      title: 'Brake & Steering Expert',
      rating: 5,
      specialization: 'Brake & Steering Specialist',
      experience: '11 Years',
      location: 'Multan',
      phone: '+92 300 8823456',
      email: 'sajid.brake@gmail.com',
      description:
        'Sajid Hussain is a brake and steering specialist with 11 years of field experience. He accurately diagnoses and fixes uneven braking, tight or loose steering, tractor pulling to one side, and suspension issues. He is widely trusted by large-scale wheat and cotton farmers across Multan Division for keeping their tractors safe and drivable.',
      skills: ['Brake Adjustment', 'Steering Repair', 'Suspension Check', 'Wheel Alignment', 'Control System'],
      availability: 'Available'
    },
    {
      id: 6,
      image: mechanic6Img,
      name: 'Ghulam Mustafa',
      title: 'Cooling System Mechanic',
      rating: 4,
      specialization: 'Cooling System Specialist',
      experience: '7 Years',
      location: 'Rawalpindi',
      phone: '+92 315 6634567',
      email: 'mustafa.cooling@gmail.com',
      description:
        'Ghulam Mustafa specializes in tractor cooling systems with 7 years of practical experience. He handles radiator blockages, overheating during field work, coolant replacement, fan belt failure, and water pump repair. He provides timely cooling system services in Rawalpindi and Islamabad, especially during the hot summer farming season.',
      skills: ['Radiator Repair & Flush', 'Coolant Replacement', 'Fan Belt & Fan Blade', 'Overheating Diagnosis', 'Water Pump Repair'],
      availability: 'Available'
    },
    {
      id: 7,
      image: mechanic7Img,
      name: 'Liaqat Ali',
      title: 'Attachment Specialist',
      rating: 5,
      specialization: 'Cutting / Attachment Specialist',
      experience: '10 Years',
      location: 'Gujranwala',
      phone: '+92 333 7745678',
      email: 'liaqat.attachment@gmail.com',
      description:
        'Liaqat Ali is a skilled attachment and cutting machinery specialist with 10 years of experience. He repairs and fine-tunes rotavators, ploughs, seed drills, threshers, and harvester blades. Farmers across Gujranwala rely on him to keep their field attachments running at peak performance throughout every crop season.',
      skills: ['Rotavator Repair', 'Plough Setting', 'Harvester Blades', 'Thresher Maintenance', 'Drill Attachment'],
      availability: 'Busy'
    },
    {
      id: 8,
      image: mechanic8Img,
      name: 'Shahbaz Ahmed',
      title: 'Tyre & Wheel Mechanic',
      rating: 4,
      specialization: 'Tyre & Wheel Specialist',
      experience: '6 Years',
      location: 'Karachi',
      phone: '+92 321 8856789',
      email: 'shahbaz.tyre@gmail.com',
      description:
        'Shahbaz Ahmed is a tyre and wheel specialist serving farmers across Karachi and Sindh for 6 years. He handles tractor tyre punctures, bent rims, wheel imbalance, and alignment problems. He offers on-site tyre fitting and replacement services, ensuring minimal downtime during critical farming operations.',
      skills: ['Tyre Puncture & Replacement', 'Rim Repair', 'Wheel Balancing', 'Alignment', 'Heavy Duty Tyre Fitting'],
      availability: 'Available'
    },
    {
      id: 9,
      image: mechanic9Img,
      name: 'Noor Muhammad',
      title: 'Body & Fabrication Expert',
      rating: 5,
      specialization: 'Body & Fabrication Specialist',
      experience: '13 Years',
      location: 'Peshawar',
      phone: '+92 300 9967890',
      email: 'noor.welding@gmail.com',
      description:
        'Noor Muhammad is a veteran body repair and fabrication expert with 13 years of experience working on tractors and farm machinery. He specializes in frame straightening, arc and MIG welding, metal body restoration, and custom attachment fabrication. He is the most trusted body specialist across Peshawar and the wider KPK region.',
      skills: ['Arc & MIG Welding', 'Frame Repair', 'Metal Body Repair', 'Custom Fabrication', 'Structural Repair'],
      availability: 'Available'
    },
    {
      id: 10,
      image: mechanic10Img,
      name: 'Imran Yousaf',
      title: 'General Service Technician',
      rating: 4,
      specialization: 'General Service Technician',
      experience: '5 Years',
      location: 'Islamabad',
      phone: '+92 346 0078901',
      email: 'imran.service@gmail.com',
      description:
        'Imran Yousaf is a dependable general service technician with 5 years of experience in routine tractor maintenance. He performs oil and filter changes, complete servicing, minor mechanical repairs, and general inspections. He offers doorstep service across Islamabad and Rawalpindi, helping farmers keep their tractors healthy before problems arise.',
      skills: ['Regular Servicing', 'Oil & Filter Change', 'Minor Repairs', 'Preventive Maintenance', 'General Inspection'],
      availability: 'Available'
    }
  ]);

  // Specialization Categories
  const [categories] = useState([
    'All',
    'Engine Specialist',
    'Electrical & Wiring Specialist',
    'Hydraulic Specialist',
    'Transmission / Gear Specialist',
    'Brake & Steering Specialist',
    'Cooling System Specialist',
    'Cutting / Attachment Specialist',
    'Tyre & Wheel Specialist',
    'Body & Fabrication Specialist',
    'General Service Technician'
  ]);

  // Selected Filter
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Filtered Mechanics based on selected category
  const filteredMechanics = selectedCategory === 'All'
    ? allMechanics
    : allMechanics.filter(mechanic => mechanic.specialization === selectedCategory);

  // Get Single Mechanic by ID
  const getMechanicById = (id) => {
    return allMechanics.find(mechanic => mechanic.id === parseInt(id));
  };

  const value = {
    allMechanics,
    filteredMechanics,
    categories,
    selectedCategory,
    setSelectedCategory,
    getMechanicById
  };

  return (
    <MechanicContext.Provider value={value}>
      {children}
    </MechanicContext.Provider>
  );
};